const desktopPanel = document.querySelector('.bundle-section__atc-box__line-items-desktop');
const desktopTrack = document.querySelector('.bundle-scrollwrap__track');
const desktopThumb = document.querySelector('.bundle-scrollwrap__thumb');
const desktopSlots = Array.from(document.querySelectorAll('.bundle-slot'));
const bundleProductsContainerMobile = document.querySelector('.bundle-section__atc-box__line-items-mobile');
const mobileTrack = document.querySelector('.bundle-mtray__track');
const mobileThumb = document.querySelector('.bundle-mtray__thumb');
const mobileSlots = Array.from(bundleProductsContainerMobile.children);
const mobilePlaceholderHTML = mobileSlots.length ? mobileSlots[0].querySelector('.bundle-mslot__media').innerHTML : '';

const addButtons = document.querySelectorAll('.atb-button');
const atcButton = document.querySelector('#AtcButton');
const submitForm = document.querySelector('form.bundle-form');
const searchBar = document.querySelector('#BundleSearch');
const productCards = Array.from(document.querySelectorAll('.bundle-product-card'));
const emptyState = document.querySelector(".empty-state");
const productList = document.querySelector(".product-list");
const filterButtons = document.querySelectorAll('.bundle-section__filter-button');
const strikePrice = document.querySelector('#strike-price');
const strikePriceDesktop = document.querySelector('#strike-price-desktop');
const actualPrice = document.querySelector('#actual-price');
const atcBoxPrice = document.querySelector('.bundle-section__atc-box__price');
const bundleDiscountValue = Number(atcBoxPrice.dataset.bundleDiscount);

const bundleUnitSize = Number(submitForm.dataset.bundleSize);

// Cap on picks of the same product: one more would form a second identical
// all-same box, whose cart line Shopify clamps to quantity 1. Still the 2+1
// number (2 * 3 - 1) — it does not yet follow bundleUnitSize.
const maxSameProduct = 5;

const desktopSlotTemplates = desktopSlots.slice(0, bundleUnitSize).map((slot) => slot.cloneNode(true));
const mobileSlotTemplates = mobileSlots.slice(0, bundleUnitSize).map((slot) => slot.cloneNode(true));

function ensureSlotCapacity(count) {
    while (desktopSlots.length < count) {
        desktopSlotTemplates.forEach((template) => {
            const slot = template.cloneNode(true);
            desktopPanel.appendChild(slot);
            desktopSlots.push(slot);
        });
        mobileSlotTemplates.forEach((template) => {
            const slot = template.cloneNode(true);
            bundleProductsContainerMobile.appendChild(slot);
            mobileSlots.push(slot);
        });
    }
}

let basket = [];

function slotItemId(card) {
    return card.querySelector('.bundle-line-item__placeholder .bundle-slot__item').dataset.id;
}

addButtons.forEach((button) => {
    button.addEventListener('click', () => {
        const card = button.closest('product-card');

        const cardId = slotItemId(card);
        const sameCount = basket.filter((entry) => slotItemId(entry) === cardId).length;
        if (sameCount >= maxSameProduct) {
            showSubmitError('Derselbe Duft darf nicht öfter als 5 Mal hinzugefügt werden.');
            return;
        }
        submitError.hidden = true;

        basket.push(card);
        renderBasket();

        desktopSlots[basket.length - 1].scrollIntoView({ block: 'nearest' });
        mobileSlots[basket.length - 1].scrollIntoView({ block: 'nearest', inline: 'nearest' });
    });
});

desktopPanel.addEventListener('click', (event) => {
    const removeButton = event.target.closest('.bundle-slot__item .bundle-slot__remove');
    if (!removeButton) return;
    const index = desktopSlots.indexOf(removeButton.closest('.bundle-slot'));
    if (index === -1 || !basket[index]) return;
    basket.splice(index, 1);
    renderBasket();
});

bundleProductsContainerMobile.addEventListener('click', (event) => {
    const slotElement = event.target.closest('.bundle-mslot');
    const index = mobileSlots.indexOf(slotElement);
    if (index === -1 || !basket[index]) return;
    basket.splice(index, 1);
    renderBasket();
});

function renderBasket() {
    const visibleSlots = Math.max(bundleUnitSize, Math.ceil(basket.length / bundleUnitSize) * bundleUnitSize);
    ensureSlotCapacity(visibleSlots);

    desktopSlots.forEach((slot, index) => {
        slot.hidden = index >= visibleSlots;

        const existingItem = slot.querySelector('.bundle-slot__item');
        if (existingItem) existingItem.remove();

        const card = basket[index];
        slot.classList.toggle('bundle-slot--filled', Boolean(card));

        if (card) {
            const template = card.querySelector('.bundle-line-item__placeholder');
            slot.insertAdjacentHTML('afterbegin', template.innerHTML);
        }
    });

    desktopPanel.classList.toggle('is-scrollable', visibleSlots > bundleUnitSize);
    bundleProductsContainerMobile.classList.toggle('is-scrollable', visibleSlots > bundleUnitSize);
    updateDesktopThumb();
    updateMobileThumb();

    mobileSlots.forEach((slotElement, index) => {
        slotElement.hidden = index >= visibleSlots;

        const card = basket[index];
        slotElement.classList.toggle('bundle-mslot--filled', Boolean(card));

        const media = slotElement.querySelector('.bundle-mslot__media');
        if (card) {
            media.innerHTML = card.querySelector('.bundle-line-item__placeholder-mobile').innerHTML;
        } else {
            media.innerHTML = mobilePlaceholderHTML;
        }
    });

    const size = basket.length;
    const isComplete = size > 0 && size % bundleUnitSize === 0;

    atcButton.disabled = !isComplete;

    updatePrices();
}

function updateDesktopThumb() {
    const maxScroll = desktopPanel.scrollHeight - desktopPanel.clientHeight;
    desktopThumb.hidden = maxScroll <= 0;
    if (maxScroll <= 0) return;

    const trackHeight = desktopTrack.clientHeight;
    const thumbHeight = Math.round(trackHeight * desktopPanel.clientHeight / desktopPanel.scrollHeight);
    const offset = (desktopPanel.scrollTop / maxScroll) * (trackHeight - thumbHeight);
    desktopThumb.style.height = thumbHeight + 'px';
    desktopThumb.style.transform = 'translateY(' + offset + 'px)';
}

desktopPanel.addEventListener('scroll', updateDesktopThumb);

function updateMobileThumb() {
    const maxScroll = bundleProductsContainerMobile.scrollWidth - bundleProductsContainerMobile.clientWidth;
    mobileThumb.hidden = maxScroll <= 0;
    if (maxScroll <= 0) return;

    const trackWidth = mobileTrack.clientWidth;
    const thumbWidth = Math.round(trackWidth * bundleProductsContainerMobile.clientWidth / bundleProductsContainerMobile.scrollWidth);
    const offset = (bundleProductsContainerMobile.scrollLeft / maxScroll) * (trackWidth - thumbWidth);
    mobileThumb.style.width = thumbWidth + 'px';
    mobileThumb.style.transform = 'translateX(' + offset + 'px)';
}

bundleProductsContainerMobile.addEventListener('scroll', updateMobileThumb);

function updatePrices() {
    const prices = basket.map((card) => {
        const price = Number(card.querySelector('.bundle-slot__item').dataset.price);
        return isNaN(price) ? 0 : price / 100;
    });
    const itemsSum = prices.reduce((sum, price) => sum + price, 0);

    const completeBundles = Math.floor(basket.length / bundleUnitSize);
    const remainderSum = prices.slice(completeBundles * bundleUnitSize).reduce((sum, price) => sum + price, 0);
    const actualTotal = completeBundles * bundleDiscountValue + remainderSum;
    const showStrike = itemsSum > actualTotal;

    const actualText = '€' + actualTotal.toFixed(2).replace('.', ',');
    const strikeText = '€' + itemsSum.toFixed(2).replace('.', ',');

    atcBoxPrice.textContent = actualText;
    actualPrice.textContent = actualText;
    strikePrice.textContent = strikeText;
    strikePrice.hidden = !showStrike;
    strikePriceDesktop.textContent = strikeText;
    strikePriceDesktop.hidden = !showStrike;
}

const submitError = document.querySelector('.bundle-form__error');

// Shopify's sold-out 422 for a bundle add names the parent line's product,
// not the component variant that is actually unavailable — and its other
// availability texts name no product at all. Stock numbers rendered into
// the page can't resolve this either (they aggregate all locations, not
// what the storefront can sell). So each component variant is probed once
// as a plain add: a 422 or a capped quantity marks the culprit, and every
// unit a probe added is removed again before returning.
async function probeSoldOutComponents(itemsArray, cartBefore) {
    const requested = new Map();
    itemsArray.forEach((item) => {
        item.properties._components.split(',').forEach((part) => {
            const [variantId, qty] = part.split(':');
            requested.set(variantId, (requested.get(variantId) || 0) + Number(qty) * item.quantity);
        });
    });

    // Propertyless quantities per variant: plain adds merge into these lines,
    // so this is the quantity a probed line gets reverted to.
    const rawQuantityBefore = new Map();
    cartBefore.items.forEach((item) => {
        if (Object.keys(item.properties || {}).length === 0) {
            rawQuantityBefore.set(String(item.variant_id), (rawQuantityBefore.get(String(item.variant_id)) || 0) + item.quantity);
        }
    });

    const cappedIds = [];
    for (const [id, quantity] of requested) {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(id), quantity }] })
        });
        const responseJson = await response.json();

        if (!response.ok) {
            cappedIds.push(id);
            continue;
        }

        const line = responseJson.items && responseJson.items[0];
        if (!line) continue;
        const before = rawQuantityBefore.get(id) || 0;
        // add.js reports the merged line total, so anything below the
        // expected total means Shopify capped the add.
        if (line.quantity < before + quantity) cappedIds.push(id);
        await fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: line.key, quantity: before })
        });
    }

    const names = cappedIds.map((id) => {
        const card = basket.find((entry) => slotItemId(entry) === id);
        if (!card) return null;
        const item = card.querySelector('.bundle-line-item__placeholder .bundle-slot__item');
        const title = item.querySelector('.bundle-slot__title').textContent.trim();
        const variantTitle = item.dataset.variantTitle;
        return variantTitle && variantTitle !== 'Default Title' ? title + ' - ' + variantTitle : title;
    }).filter(Boolean);

    if (names.length === 1) return "Das Produkt '" + names[0] + "' ist bereits ausverkauft.";
    if (names.length > 1) return "Die Produkte '" + names.join("', '") + "' sind bereits ausverkauft.";
    return null;
}

function showSubmitError(message) {
    submitError.textContent = message || 'Dein Bundle konnte nicht hinzugefügt werden. Bitte versuche es erneut.';
    submitError.hidden = false;
}

submitForm.addEventListener('submit', async (event) => {
    event.preventDefault();

    if (basket.length === 0 || basket.length % bundleUnitSize !== 0) return;

    submitError.hidden = true;

    // One cart line per distinct composition: the bundle parent variant is added
    // with the picked fragrances in `_components`, the cart transform expands the
    // line. Identical compositions collapse into the line quantity, so the native
    // quantity stepper works on bundle lines.
    const bundleCount = basket.length / bundleUnitSize;
    const compositions = new Map();

    for (let bundleIndex = 0; bundleIndex < bundleCount; bundleIndex++) {
        const groupCards = basket.slice(bundleIndex * bundleUnitSize, (bundleIndex + 1) * bundleUnitSize);

        const aggregated = new Map();
        groupCards.forEach((card) => {
            const item = card.querySelector('.bundle-line-item__placeholder .bundle-slot__item');
            const itemId = item.dataset.id;

            if (!aggregated.has(itemId)) {
                const variantTitle = item.dataset.variantTitle === 'Default Title' ? '' : item.dataset.variantTitle;
                aggregated.set(itemId, {
                    quantity: 0,
                    priceCents: Number(item.dataset.price) || 0,
                    discount: item.querySelector('[data-property]').value,
                    handle: item.dataset.handle,
                    title: item.querySelector('.bundle-slot__title').textContent.trim(),
                    variantTitle: variantTitle
                });
            }
            aggregated.get(itemId).quantity += 1;
        });

        // Sorted by variant ID so identical compositions always serialize identically;
        // the price (in cents) lets the cart transform compute the markdown
        const entries = Array.from(aggregated.entries()).sort((a, b) => a[0].localeCompare(b[0]));
        const componentsKey = entries.map(([itemId, entry]) => itemId + ':' + entry.quantity + ':' + entry.priceCents).join(',');

        if (compositions.has(componentsKey)) {
            compositions.get(componentsKey).quantity += 1;
        } else {
            compositions.set(componentsKey, {
                quantity: 1,
                discount: entries[0][1].discount,
                richComponents: entries
                    .map(([, entry]) => entry.handle + '##' + entry.title + '##' + entry.variantTitle + '##' + entry.quantity)
                    .join('|||')
            });
        }
    }

    const itemsArray = Array.from(compositions.entries()).map(([componentsKey, bundle]) => ({
        id: submitForm.dataset.variantId,
        quantity: bundle.quantity,
        properties: {
            "_components": componentsKey,
            "_bundleDiscount": bundle.discount,
            "_rich_components": bundle.richComponents
        }
    }));

    const sectionsToBundle = [];
    document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
    );

    const formData = {
        items: itemsArray,
        sections: sectionsToBundle.join(',')
    };

    try {
      const cartBefore = await (await fetch(`${Shopify.routes.root}cart.js`)).json();

      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
      const responseJson = await response.json();
      const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();

      if (!response.ok) {
        const description = responseJson.description || responseJson.message || '';

        // Shopify's availability description reports wrong counts for expanded
        // bundle lines; show the actual per-variant cart limit instead.
        if (/Verfügbarkeit|availability/i.test(description)) {
          showSubmitError('Derselbe Duft darf als Bundle nicht öfter als 5 Mal zum Warenkorb hinzugefügt werden.');
        } else if (/ausverkauft|sold out/i.test(description)) {
          let componentMessage = null;
          try {
            componentMessage = await probeSoldOutComponents(itemsArray, cartBefore);
          } catch (probeError) {
            console.error('Error:', probeError);
          }
          showSubmitError(componentMessage || description);
        } else {
          showSubmitError(description);
        }

        if (cartContent.item_count > cartBefore.item_count) {
          document.documentElement.dispatchEvent(
              new CustomEvent('cart:refresh', { bubbles: true })
          );
        }
        return;
      }

      if (responseJson.sections) {
        cartContent['sections'] = responseJson['sections'];

        document.documentElement.dispatchEvent(
            new CustomEvent('cart:change', {
                bubbles: true,
                detail: {
                    baseEvent: 'variant:add',
                    cart: cartContent
                }
            })
        );
      } else {
        // Without bundled sections, cart:change would crash the drawer's
        // onCartChange handler (it reads cart.sections unguarded); cart:refresh
        // lets the drawer refetch its own section instead.
        document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', { bubbles: true })
        );
      }

      basket = [];
      renderBasket();
    } catch (error) {
      console.error('Error:', error);
      showSubmitError();
    }
})

searchBar.addEventListener("input", () => {
  applyFilters();
});

filterButtons.forEach((button) => {
  button.addEventListener("click", () => {
    button.classList.toggle("active");
    applyFilters();
  });
});

function applyFilters() {
  const activeFilters = Array.from(filterButtons)
    .filter((button) => button.classList.contains("active"))
    .map((button) => ({
      group: button.dataset.filterGroup,
      value: button.dataset.filterValue,
    }));

  const filtersByGroup = {};
  activeFilters.forEach((filter) => {
    if (!filtersByGroup[filter.group]) {
      filtersByGroup[filter.group] = [];
    }
    filtersByGroup[filter.group].push(filter.value);
  });

  const activeFilterGroups = Object.keys(filtersByGroup);
  const searchBarInput = searchBar.value.toLowerCase();

  let visibleCount = 0;
  productCards.forEach((card) => {
    let matchesAllGroups = true;

    if (activeFilterGroups.length > 0) {
      for (const filterGroup of activeFilterGroups) {
        const cardFilterAttribute = `data-filter-group-${filterGroup}`;
        const cardFilterValue = card.getAttribute(cardFilterAttribute);

        if (!cardFilterValue) {
          matchesAllGroups = false;
          break;
        }

        const selectedValues = filtersByGroup[filterGroup];
        const cardFilterValues = cardFilterValue
          .split(",")
          .map((value) => value.trim())
          .filter((value) => value !== "");

        const hasMatch = cardFilterValues.some((value) =>
          selectedValues.includes(value)
        );

        if (!hasMatch) {
          matchesAllGroups = false;
          break;
        }
      }
    }

    const matchesSearch =
      searchBarInput === "" ||
      card.dataset.productTitle.toLowerCase().includes(searchBarInput);

    if (matchesAllGroups && matchesSearch) {
      card.classList.remove("hidden");
      visibleCount++;
    } else {
      card.classList.add("hidden");
    }
  });

  updateEmptyState();
}

function updateEmptyState() {
  const visibleCards = productCards.filter(
    (card) => !card.classList.contains("hidden")
  );

  if (visibleCards.length === 0) {
    emptyState.classList.remove("hidden");
    productList.classList.add("hidden");
  } else {
    emptyState.classList.add("hidden");
    productList.classList.remove("hidden");
  }
}

// Title and short description share a 4-line budget: every extra line the
// title wraps to takes one clamp line away from the description.
function clampShortDescriptions() {
  const clamps = productCards.map((card) => {
    const title = card.querySelector('.productVendorTitle--custom');
    const description = card.querySelector('.short_description--productPage');
    if (!title || !description || !title.offsetHeight) return null;

    const style = getComputedStyle(title);
    const lineHeight = parseFloat(style.lineHeight) || parseFloat(style.fontSize) * 1.2;
    const titleLines = Math.max(1, Math.round(title.offsetHeight / lineHeight));
    return { description, lines: Math.max(1, 4 - titleLines) };
  });

  clamps.forEach((clamp) => {
    if (!clamp) return;
    clamp.description.style.setProperty('-webkit-line-clamp', clamp.lines);
    clamp.description.style.setProperty('line-clamp', clamp.lines);
  });
}

let clampResizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(clampResizeTimeout);
  clampResizeTimeout = setTimeout(clampShortDescriptions, 150);
});
window.addEventListener('load', clampShortDescriptions);
clampShortDescriptions();

// Preselect fragrances from the URL, e.g. /products/bundles?bundle=383,501,384
// The values are product handles — Elusa numbers its fragrances, so the handle
// of "383" is literally "383" — which lets a campaign link open the builder
// with a box already filled. `products` is accepted as an alias.
//
// Handles the page does not render are skipped rather than reported: a card is
// only in the DOM when the product has an available variant in this bundle's
// ml size, so a link shared across the 15ml and 100ml builders legitimately
// resolves to different subsets, and a sold-out fragrance simply drops out.
function preselectFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const requested = (params.get('bundle') || params.get('products') || params.get('p') || '')
        .split(',')
        .map((value) => value.trim().toLowerCase())
        .filter(Boolean);

    if (requested.length === 0) return;

    const cardsByHandle = new Map();
    productCards.forEach((wrapper) => {
        const card = wrapper.querySelector('product-card');
        const handle = (card && card.getAttribute('handle') || '').trim().toLowerCase();
        if (handle && !cardsByHandle.has(handle)) cardsByHandle.set(handle, card);
    });

    const skipped = [];
    requested.forEach((handle) => {
        const card = cardsByHandle.get(handle);
        if (!card) {
            skipped.push(handle);
            return;
        }

        const cardId = slotItemId(card);
        const sameCount = basket.filter((entry) => slotItemId(entry) === cardId).length;
        if (sameCount >= maxSameProduct) {
            skipped.push(handle);
            return;
        }

        basket.push(card);
    });

    if (skipped.length > 0) {
        console.warn('Bundle-Vorauswahl übersprungen:', skipped.join(', '));
    }

    if (basket.length > 0) renderBasket();
}

preselectFromUrl();
